var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.97187 0 0 8.97187 0 20C0 31.0281 8.97187 40 20 40C31.0281 40 40 31.0281 40 20C40 8.97187 31.0281 0 20 0ZM24.5117 27.1547C25.1633 27.8062 25.1633 28.8594 24.5117 29.5117C24.1867 29.8367 23.7602 30 23.3336 30C22.907 30 22.4805 29.8367 22.1555 29.5117L13.8219 21.1781C13.1703 20.5266 13.1703 19.4734 13.8219 18.8211L22.1555 10.4875C22.807 9.83594 23.8602 9.83594 24.5125 10.4875C25.1648 11.1391 25.1641 12.1922 24.5125 12.8445L17.3578 19.9992L24.5125 27.1539L24.5117 27.1547Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.aa8a4d0e19d92a512bd6cf723e23bb09.svg";
export { ForwardRef as ReactComponent };